import { isNative } from '../device';
import { IndexedDbStorage } from './idb-storage';
import { SqliteStorage } from './sqlite-storage';
import type { OfflineStorage } from './types';

export * from './types';
export { IndexedDbStorage } from './idb-storage';
export { SqliteStorage } from './sqlite-storage';

/** Encrypted SQLite on the store apps, IndexedDB in browsers / the PWA. */
export function createOfflineStorage(): OfflineStorage {
  return isNative() ? new SqliteStorage() : new IndexedDbStorage();
}
